import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';
import { useSuspensionStatus } from '@/hooks/useSuspensionStatus';
import { supabase } from '@/integrations/supabase/client';

/**
 * Blocks a suspended account from using the app. Admins always pass through.
 */
export const SuspensionGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { suspension, loading } = useSuspensionStatus();

  if (loading || !suspension) return <>{children}</>;

  return (
    <div className="min-h-dvh flex items-center justify-center p-6">
      <Card className="max-w-md w-full">
        <CardContent className="p-6 space-y-4 text-center">
          <div className="flex justify-center">
            <ShieldAlert className="h-12 w-12 text-destructive" />
          </div>
          <div className="space-y-1">
            <h1 className="text-xl font-bold">Account suspended</h1>
            <p className="text-sm text-muted-foreground">{suspension.reason}</p>
          </div>
          <p className="text-xs text-muted-foreground">
            {suspension.is_permanent
              ? 'This suspension is permanent.'
              : `Access returns ${suspension.expires_at ? new Date(suspension.expires_at).toLocaleString() : 'once the suspension expires'}.`}
          </p>
          <p className="text-xs text-muted-foreground">
            If you believe this is a mistake, reply to your account email to appeal.
          </p>
          <Button variant="outline" size="sm" onClick={() => supabase.auth.signOut()}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};